import React from 'react';
import { CustomTextField } from '../../commons/CustomTextField';
import { TextWrapper, Wrapper } from './Main.Styles';
export var MainForm = function (_a) {
    // const [phoneTypes, setPhoneTypes] = useState([
    //   'Home',
    //   'Cell',
    //   'Work',
    //   'Other',
    // ] as string[]);
    // const [pTValueStatus, setPTValueStatus] = useState(false);
    var formValues = _a.formValues, creating = _a.creating;
    // useEffect(() => {
    //   setPhoneTypes;
    //   // if (!creating) setPhoneTypes(formValues.PhoneTypes);
    //   // else setPhoneTypes(['Home', 'Cell', 'Work', 'Other']);
    // }, [formValues.PhoneTypes]);
    return (React.createElement(Wrapper, null,
        React.createElement(TextWrapper, null,
            React.createElement(CustomTextField, { name: 'contactListTable', label: 'Contact List Table' }),
            React.createElement(CustomTextField, { name: 'phoneListTable', label: 'Phone List Table' }),
            React.createElement(CustomTextField, { name: 'doNotCallTable', label: 'DNC Table' }),
            React.createElement(CustomTextField, { name: 'dncUniqueRecordIdentifier', label: 'DNC Unique Record Identifier' }),
            React.createElement(CustomTextField, { name: 'phoneTypes', label: 'Phone Types' }))));
};
MainForm.defaultProps = {};
//# sourceMappingURL=Main.js.map